import { isNumber } from 'lodash-es';
import { HotspotLocation, HotspotType } from '@marvelapp/core';
import * as hotspotAction from '../constants/hotspotAction';
export function isHeader(_a) {
    var type = _a.type, location = _a.location;
    return (type === HotspotType.FixedHorizontal && location === HotspotLocation.Top);
}
export function isFooter(_a) {
    var type = _a.type, location = _a.location;
    return (type === HotspotType.FixedHorizontal && location === HotspotLocation.Bottom);
}
export function isTimer(_a) {
    var action = _a.action, timer = _a.timer;
    return action === hotspotAction.TIMER && isNumber(timer) && timer > 0;
}
export function overlapsHeader(headerHotspot, _a) {
    var y = _a.y, y2 = _a.y2;
    return headerHotspot && (y <= headerHotspot.y || y2 <= headerHotspot.y);
}
export function overlapsFooter(footerHotspot, _a) {
    var y = _a.y, y2 = _a.y2;
    return footerHotspot && (y >= footerHotspot.y || y2 >= footerHotspot.y);
}
export function hasValidDestination(hotspot, screenIDList) {
    return screenIDList.indexOf(hotspot.destinationScreenID) !== -1;
}
export function isMouseOutsideHotspot(event, hotspotInfo, scrollPos) {
    var hotspotPosition = hotspotInfo.coordinates;
    var amountScrolled = 0;
    // This is required to ensure that we keep existing behaviour
    // and consistency of how maintainScroll is expected to work.
    //
    // The user should only be able to scroll out of hotspots
    // for hotspots with maintainScroll === true, otherwise all hotspots
    // will partially behave as if maintainScroll is true.
    //
    // If you can scroll out of the hotspot, it implies that the original screen has also scrolled.
    // Therefore when you hover out, you should see the new scroll position of the original screen.
    // This would mean that it partially behaves like maintainScroll is true,
    // i.e. it maintains the scroll positioning of the original screen.
    if (hotspotInfo.maintainScroll) {
        // account for user scrolling out of the hotspot
        amountScrolled = hotspotInfo.scrollPos.previous - scrollPos;
    }
    return (event.pageX < hotspotPosition.left ||
        event.pageX > hotspotPosition.right ||
        event.pageY < hotspotPosition.top + amountScrolled ||
        event.pageY > hotspotPosition.bottom + amountScrolled);
}
